@if (show) {
<div class="assistant-overlay" (click)="onOverlayClick($event)">
  <div class="assistant-panel">
    <div class="panel-header">
      <div class="header-left">
        <div class="robot-avatar">
          <fa-icon [icon]="icons.faWandMagicSparkles"></fa-icon>
        </div>
        <div class="header-info">
          <h3>{{ 'PROCESSINGS.ASSISTANT.TITLE' | translate }}</h3>
          <span class="step-indicator">{{ 'PROCESSINGS.ASSISTANT.SUBTITLE' | translate }}</span>
        </div>
      </div>
      <button type="button" class="close-btn" (click)="onClose()">
        <fa-icon [icon]="icons.faTimes"></fa-icon>
      </button>
    </div>

    <div class="progress-track">
      <div class="progress-fill"></div>
    </div>

    <div class="panel-body">
      <textarea
        class="assistant-input"
        rows="3"
        [(ngModel)]="text"
        [placeholder]="'PROCESSINGS.ASSISTANT.PLACEHOLDER' | translate"></textarea>

      @if (suggestions.length) {
        <div class="assistant-suggestions">
          @for (suggestion of suggestions; track trackByIndex($index)) {
            <div class="suggestion-card">
              <div class="suggestion-body">
                <span class="suggestion-type" [class.suggestion-type--ai]="suggestion.type === 'ai'">
                  {{ (suggestion.type === 'ai' ? 'PROCESSINGS.OPERATIONS.TYPE_AI' : 'PROCESSINGS.OPERATIONS.TYPE_JSONATA') | translate }}
                </span>
                <span class="suggestion-description">{{ suggestion.description }}</span>
                @if (suggestion.type === 'jsonata' && suggestion.expression) {
                  <code class="suggestion-expression">{{ suggestion.expression }}</code>
                }
              </div>
              <button type="button" class="suggestion-add" (click)="add(suggestion)"
                [title]="'PROCESSINGS.ASSISTANT.ADD' | translate">
                <fa-icon [icon]="icons.faPlus"></fa-icon>
              </button>
            </div>
          }
        </div>
      }
    </div>

    <div class="panel-footer">
      <button type="button" class="assistant-clear"
        [disabled]="loading || (!text.trim() && !suggestions.length)" (click)="clear()">
        <fa-icon [icon]="icons.faEraser"></fa-icon>
        <span>{{ 'PROCESSINGS.ASSISTANT.CLEAR' | translate }}</span>
      </button>
      <button type="button" class="assistant-generate" [disabled]="loading || !text.trim()" (click)="generate()">
        @if (loading) {
          <fa-icon [icon]="icons.faSpinner" animation="spin"></fa-icon>
        } @else {
          <fa-icon [icon]="icons.faWandMagicSparkles"></fa-icon>
        }
        <span>{{ 'PROCESSINGS.ASSISTANT.GENERATE' | translate }}</span>
      </button>
    </div>
  </div>
</div>
}
